import CollectionChange from 'owa-mail-store/lib/store/schema/CollectionChange';
import { FirstLoadConversationReadingPaneState } from './actions/firstLoadConversationReadingPane';
import { LazyAction, LazyModule } from 'owa-bundling';
import * as lazyIndex from './lazyIndex';

const lazyModule = new LazyModule(() =>
    System.import<typeof lazyIndex>(/* webpackChunkName: "ReadingPane" */ './lazyIndex')
);

export let lazyPostLoadConversation = new LazyAction(lazyModule, m => m.postLoadConversation);
export let lazyFirstLoadConversationReadingPane = new LazyAction(
    lazyModule,
    m => m.firstLoadConversationReadingPane
);

export { CollectionChange, FirstLoadConversationReadingPaneState };
